import { render, staticRenderFns } from "./OpsheadCandDashboard.vue?vue&type=template&id=07748994&scoped=true&"
import script from "./OpsheadCandDashboard.vue?vue&type=script&lang=js&"
export * from "./OpsheadCandDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OpsheadCandDashboard.vue?vue&type=style&index=0&id=07748994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07748994",
  null
  
)

export default component.exports